"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _CardBox = require("../CardBox");
require("./Title.scss");
var Title = function Title(_ref) {
  var children = _ref.children,
    titleSize = _ref.titleSize,
    titleActions = _ref.titleActions,
    className = _ref.className,
    headingClassName = _ref.headingClassName;
  var rootClassNames = (0, _classnames["default"])('cds-CardBox-Title', className);
  var headingClassNames = (0, _classnames["default"])('cds-CardBox-TitleHeading', (0, _defineProperty2["default"])({}, "cds-CardBox-TitleHeading--".concat((0, _upperCaseFirst.upperCaseFirst)(titleSize || '')), titleSize !== _CardBox.CARD_BOX_TITLE_SIZE["default"]), headingClassName);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassNames
  }, titleSize === _CardBox.CARD_BOX_TITLE_SIZE.large ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: headingClassNames
  }, children) : /*#__PURE__*/_react["default"].createElement("h3", {
    className: headingClassNames
  }, children), titleActions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CardBox-TitleActions"
  }, titleActions));
};
exports.Title = Title;